import { useContext, useState } from "react";
import UiContext from "../../../../store/ui-context";
import useAPIRequest from "../../../../custom_hooks/simple/useAPIRequest";

export const useAPIgetPackageByBC = () => {
  const uiContext = useContext(UiContext);
  const { requestGetOne, requestGet, loading } = useAPIRequest();
  const [data, setData] = useState(null);
  const [error, setError] = useState({});

  const sumAll = (items, field) => {
    if (!items || items.length === 0) return 0;

    return items.reduce((sum, item) => sum + (item[field] || 0), 0);
  };

  const fetchData = async ({ filter }) => {
    if (!validate()) {
      return;
    }

    return requestGet({
      fullUrl: `/api/report`,
      params: {
        prefix: "remaining_packages_bc",
        page: 1,
        take: 10000000,
      },
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
      onSuccess: ({ data: _data, message, pagination }) => {
        const previousBCItems = _data.filter(
          (item) => item.bc_id === 22 || item.bc_id === 23
        );
        const previousBCTotal = previousBCItems.reduce(
          (sum, item) => sum + item.total,
          0
        );
        const filteredData = _data.filter(
          (item) => item.bc_id !== 22 && item.bc_id !== 23
        );

        let sortedData;
        if (previousBCTotal > 0) {
          const combinedData = [
            ...filteredData,
            {
              bc_name: "Previous BC",
              total: previousBCTotal,
            },
          ];

          sortedData = combinedData.sort((a, b) => b.total - a.total);
        } else {
          sortedData = filteredData.sort((a, b) => b.total - a.total);
        }

        setData({
          items: sortedData,
          max: sumAll(filteredData, "total") + previousBCTotal,
          rawData: _data,
        });
      },
    });
  };

  const validate = () => {
    let isValid = true;

    return isValid;
  };

  return {
    data,
    setData,
    error,
    setError,
    fetchData,
    loading,
  };
};
